// Pager — simple prev/next pagination controls.
// Pure presentation component; no data fetching.

import { Button } from "../ui/Button";
import { useTranslation } from "../i18n";

export interface PagerProps {
  readonly page: number;
  readonly hasMore: boolean;
  readonly onPage: (page: number) => void;
}

export function Pager({ page, hasMore, onPage }: PagerProps) {
  const { t } = useTranslation("history");
  return (
    <nav className="flex items-center justify-between gap-3" aria-label={t("pager.ariaLabel")}>
      <Button
        variant="secondary"
        size="sm"
        disabled={page <= 1}
        onClick={() => onPage(page - 1)}
      >
        {t("pager.previous")}
      </Button>
      <span className="text-xs text-slate-500">{t("pager.page", { page })}</span>
      <Button
        variant="secondary"
        size="sm"
        disabled={!hasMore}
        onClick={() => onPage(page + 1)}
      >
        {t("pager.next")}
      </Button>
    </nav>
  );
}
